import { del, get, post } from "@/infra/rest";
import { APIEndpoints } from "@/shared/constants/Endpoints";

export interface WhitelistDomain {
  id: string;
  organization_id: string;
  email_domain: string;
  domain: string;
  organization_name: string;
  custom_access_link: string;
  public_identifier: string;
  status: string;
  created_at: string;
  updated_at: string;
  used_count: number;
  success_count: number;
  failure_count: number;
  /** Preferred access URL. Falls back to custom_access_link when absent. */
  full_url: string;
}

export interface GetWhitelistedDomainsResponse {
  success: boolean;
  data: WhitelistDomain[];
  message?: string;
}

export interface RevokeWhitelistedDomainResponse {
  message: string;
}

export const getWhitelistedDomains = async (): Promise<GetWhitelistedDomainsResponse> => {
  return get<GetWhitelistedDomainsResponse>({
    url: APIEndpoints.WhitelistedDomains,
    isAuthRequired: true,
  });
};

export const getWhitelistedDomainsList = async (): Promise<WhitelistDomain[]> => {
  const response = await getWhitelistedDomains();

  if (!response.success) {
    throw new Error(response.message || "Failed to fetch whitelisted domains.");
  }

  if (!Array.isArray(response.data)) {
    throw new Error("Invalid whitelisted domains response.");
  }

  return response.data;
};

export const createWhitelistedDomain = async (emailDomain: string): Promise<WhitelistDomain> => {
  return post<{ email_domain: string }, WhitelistDomain>({
    url: APIEndpoints.WhitelistedDomains,
    data: {
      email_domain: emailDomain,
    },
    isAuthRequired: true,
  });
};

export const revokeWhitelistedDomain = async (whitelistId: string): Promise<RevokeWhitelistedDomainResponse> => {
  return del<RevokeWhitelistedDomainResponse>({
    url: `${APIEndpoints.WhitelistedDomains}/${whitelistId}`,
    isAuthRequired: true,
  });
};
